var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _excluded = ["size", "color"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

var React = require("react");

module.exports = function (a) {
  var _a$size = a.size,
      c = _a$size === void 0 ? "1em" : _a$size,
      _a$color = a.color,
      d = _a$color === void 0 ? "#010101" : _a$color,
      b = _objectWithoutProperties(a, _excluded);

  return b = _objectSpread(_objectSpread({}, b), {}, {
    style: _objectSpread(_objectSpread({}, b.style ? b.style : {}), {}, {
      width: c,
      height: c
    }, d ? {
      fill: d
    } : {})
  }), /*#__PURE__*/React.createElement("svg", _extends({}, b, {
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: "0",
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: "0",
      shapeMargin: "0",
      inlineSize: "0",
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: "1"
    },
    d: "M20.095 84.095C9.017 84.095 0 75.078 0 64s9.017-20.095 20.095-20.095S40.19 52.922 40.19 64s-9.017 20.095-20.095 20.095zm0-3.356c9.265 0 16.74-7.474 16.74-16.739s-7.475-16.74-16.74-16.74A16.714 16.714 0 003.355 64c0 9.265 7.475 16.74 16.74 16.74z",
    fontFamily: "sans-serif",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.723 63.103c4.4-3.595 8.705-7.314 13.201-10.804-2.358 3.624-4.784 7.2-7.142 10.823-2.023.01-4.046.01-6.059-.019zM18.443 65.107c2.032 0 4.055 0 6.078.029-4.43 3.576-8.714 7.324-13.22 10.804 2.358-3.624 4.784-7.21 7.142-10.833z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.019 70.548c.825.459 2.04.78 3.393.78 2.958 0 4.54-1.468 4.54-3.485-.023-1.651-.963-2.683-2.98-3.417-1.422-.504-1.95-.848-1.95-1.559 0-.687.55-1.169 1.56-1.169.985 0 1.88.367 2.361.642l.55-1.995c-.642-.344-1.72-.665-2.958-.665-2.59 0-4.218 1.536-4.218 3.508-.023 1.307.894 2.5 3.072 3.256 1.376.482 1.834.871 1.834 1.628 0 .734-.55 1.238-1.788 1.238-1.009 0-2.224-.413-2.866-.802zm14.36-10.868c-3.37 0-5.777 2.247-5.777 5.915 0 3.577 2.43 5.755 5.594 5.755 2.843 0 5.732-1.834 5.732-5.938 0-3.393-2.224-5.732-5.549-5.732zm-.068 2.063c1.926 0 2.705 1.995 2.705 3.738 0 2.247-1.123 3.829-2.728 3.829-1.72 0-2.774-1.628-2.774-3.783 0-1.858.802-3.784 2.797-3.784zm14.796 6.925c-.55.23-1.238.435-2.224.435-1.926 0-3.416-1.306-3.416-3.6-.023-2.04 1.26-3.622 3.416-3.622 1.009 0 1.674.23 2.132.436l.505-2.11c-.642-.298-1.697-.527-2.729-.527-3.92 0-6.213 2.614-6.213 5.961 0 3.462 2.27 5.686 5.755 5.686 1.398 0 2.568-.298 3.164-.573zm4.341-13.85h-2.82v16.28h2.82v-3.806l.963-1.124 3.21 4.93h3.462l-4.723-6.603 4.127-4.563h-3.393l-2.706 3.6c-.298.39-.619.87-.894 1.307h-.046zm17.204 11.488c.046-.253.092-.665.092-1.193 0-2.453-1.192-5.434-4.815-5.434-3.577 0-5.457 2.912-5.457 6.008 0 3.416 2.133 5.64 5.755 5.64 1.605 0 2.935-.298 3.898-.688l-.413-1.949c-.848.321-1.788.505-3.095.505-1.788 0-3.37-.872-3.44-2.89zm-7.474-1.972c.114-1.147.848-2.729 2.59-2.729 1.88 0 2.34 1.697 2.316 2.729zm9.362-6.925v2.523h-1.605v2.109h1.605v5.25c0 1.468.275 2.477.871 3.119.528.573 1.399.917 2.43.917.895 0 1.629-.115 2.041-.275l-.045-2.155c-.253.068-.62.137-1.1.137-1.079 0-1.445-.71-1.445-2.063v-4.93h2.682v-2.11h-2.682v-3.186zm7.872 13.94c1.055 0 1.743-.78 1.743-1.81 0-1.079-.71-1.812-1.743-1.812-1.009 0-1.742.756-1.742 1.811 0 1.032.71 1.811 1.742 1.811zm5.9-.252V59.931h-2.843v11.166zm-1.421-15.82c-.94 0-1.582.664-1.582 1.535 0 .849.619 1.514 1.56 1.514.985 0 1.604-.665 1.604-1.514-.023-.87-.619-1.536-1.582-1.536zm8.56 4.401c-3.37 0-5.778 2.248-5.778 5.916 0 3.577 2.43 5.755 5.595 5.755 2.843 0 5.732-1.834 5.732-5.938 0-3.394-2.224-5.733-5.549-5.733zm-.069 2.064c1.926 0 2.706 1.995 2.706 3.737 0 2.247-1.124 3.83-2.729 3.83-1.72 0-2.774-1.628-2.774-3.784 0-1.857.802-3.783 2.797-3.783z"
  })));
};